import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  ResendDigitalSignatureRequestClientRequest,
  ResendDigitalSignatureRequestClientResponse,
} from '../../../@types/resendDigitalSignature'
import { api } from '../../../Services/API'
import { useWarningStore } from '../../../Stores/warningStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { WARNING_BAR } from '../../../constants/warningBar'
import { t } from '../../../i18n'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: ResendDigitalSignatureRequestClientRequest) => {
  const response = await api.post<ResendDigitalSignatureRequestClientResponse>(
    API_ROUTES.resendDigitalSignature,
    payload,
  )

  return response.data
}

export const useResendDigitalSignature = () => {
  const { setWarningOptions } = useWarningStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: ResendDigitalSignatureRequestClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setWarningOptions({
        type: WARNING_BAR.type.success,
        labelTypes: [t('general.success.emailSent')],
        mode: WARNING_BAR.mode.show,
      })
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({
        message: t('pages.step2.report.errors.emailNotSent'),
        error,
      })
    },
  })
}
